import React from "react";
import PropTypes from "prop-types";
import TransitionGroup from "react-transition-group/TransitionGroup";
import CSSTransition from "react-transition-group/CSSTransition";
import { connect } from "react-redux";

import { setMessage } from "actions/message";
import Message from "./Message";
import { MESSAGES } from "config/constants";

import styles from "./MessagePanel.css";

class MessagePanel extends React.Component {
  render() {
    const { message, setMessage } = this.props;
    const { enter, exit, enterActive, exitActive } = styles;

    return (
      <TransitionGroup
        className={styles.root}
        aria-atomic="true"
        aria-live="assertive"
      >
        {message.message ? (
          <CSSTransition
            classNames={{ enter, exit, enterActive, exitActive }}
            timeout={150}
            unmountOnExit={true}
          >
            <Message
              expire={() => setMessage({})}
              message={message.message}
              type={message.type}
            />
          </CSSTransition>
        ) : null}
      </TransitionGroup>
    );
  }
}

MessagePanel.propTypes = {
  message: PropTypes.shape({
    message: PropTypes.oneOfType([
      PropTypes.instanceOf(Error),
      PropTypes.string,
      PropTypes.element,
    ]),
    type: PropTypes.oneOf(Object.keys(MESSAGES)),
  }),
  setMessage: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  message: state.message,
});

const mapDispatchToProps = {
  setMessage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MessagePanel);
